import { DATA, ENTITY, KEY, Resource } from "shelving";

export const ADD_LIST_ITEM = new Resource("addListItem", DATA({ id: KEY, item: ENTITY }));
export const REMOVE_LIST_ITEM = new Resource("removeListItem", DATA({ id: KEY, item: ENTITY }));
